import { Injectable } from '@angular/core';
import { HttpFunctionResult } from '../_interfaces/HttpFunctionResult';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor() { }

  /**
   * Kopiert den angegebenen Text in die Zwischenablage.
   * 
   * @param text Der zu kopierende Text.
   */
  public async copyToClipboard(text: string): Promise<void> {
    if(window.isSecureContext && navigator.clipboard) await navigator.clipboard.writeText(text)
    else {
      // Muss verwendet werden, wenn der Browser das Clipboard API nicht unterstützt.
      // Oder wenn die Seite nicht über HTTPS aufgerufen wird.
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);}
  }

  /**
   * Liest den Inhalt der Zwischenablage und gibt ihn als Zeichenkette zurück.
   * 
   * @returns Eine Promise, die den Inhalt der Zwischenablage als Zeichenkette enthält.
   */
  public async getClipboardText(): Promise<HttpFunctionResult<string>> {
    if(window.isSecureContext && navigator.clipboard) return {success: true, data: await navigator.clipboard.readText()}
    else return {success: false, message: "Objekte können aus Sicherheitsgründen nur über HTTPS aus dem Clipboard gelesen werden."}
  }
}
